import {
  AppWindow,
  Bell,
  ChartLine,
  Gauge,
  Link as LinkIcon,
  QrCode,
  ReceiptText,
  SlidersHorizontal,
} from 'lucide-react';

import { getSettingsSections } from '../../scenes/PageSettings/PageSettings';

const ITEMS = [
  {
    key: 'general',
    label: 'General',
    icon: SlidersHorizontal,
    paths: ['/url-slug', '/google-index', '/redirect-page'],
  },
  { key: 'limits', icon: Gauge, paths: ['/limits'] },
  { key: 'email-notifications', icon: Bell, paths: ['/email-notifications'] },
  { key: 'ticket-qr-codes', icon: QrCode, paths: ['/ticket-qr-codes'] },
  { key: 'invoices', icon: ReceiptText, paths: ['/invoices'] },
  { key: 'tracking-pixels', icon: ChartLine, paths: ['/tracking-pixels'] },
  { key: 'dynamic-info', icon: LinkIcon, paths: ['/dynamic-info'] },
  { key: 'pop-up-behavior', icon: AppWindow, paths: ['/pop-up-behavior'] },
];

// The settings modal's sidebar for this page. An item with one setting takes that setting's
// name; items whose settings this page doesn't show are left out.
export function getSettingsItems({ page, seller }) {
  const sections = getSettingsSections({ page, seller }).filter(section => !section.hidden);

  return ITEMS.map(item => {
    const itemSections = item.paths
      .map(path => sections.find(section => section.path === path))
      .filter(Boolean);
    return {
      key: item.key,
      icon: item.icon,
      sections: itemSections,
      label: item.label ?? itemSections[0]?.label,
    };
  }).filter(item => item.sections.length);
}

/** The item showing this setting (`url-slug`, `limits`...), or the first item. */
export function findSettingsItem(items, setting) {
  return items.find(item => item.sections.some(s => s.path === `/${setting}`)) ?? items[0];
}
